/** @jsx jsx */
import { jsx } from '@emotion/react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash/get';

import Flex from '../flex/flex';

import css from './fieldset.css';

export default function Fieldset(
  {
    children,
    className,
    element: Element,
    errors,
    extra,
    groupLabel,
    labelElement: Label,
    label,
    large,
    loose,
    name,
    tight,
    ...rest
  },
  context,
) {
  const allErrors = errors.concat(context.errors);
  const ownErrors = allErrors
    .filter((item) => !!item)
    .filter((error) => get(error, 'property') === name);
  const ownClassName = classNames('form-group', className, {
    'form-group-lg': large === true,
    'has-error': ownErrors.length,
  });
  return (
    <Element {...rest} className={ownClassName} css={css({ loose, tight })}>
      {groupLabel && <h5 className="header">{groupLabel}</h5>}
      {label ? (
        <Label className="fieldset__label">
          <Flex alignItems="center" justifyContent="space-between">
            <h5 className="fieldset__header">{label}</h5>
            {extra}
          </Flex>
          {children}
        </Label>
      ) : (
        children
      )}
      {ownErrors.map(({ message }) => (
        <div className="fieldset__error" key={message}>
          {message}
        </div>
      ))}
    </Element>
  );
}

Fieldset.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  element: PropTypes.string,
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      message: PropTypes.string,
      property: PropTypes.string,
    }),
  ),
  extra: PropTypes.node,
  groupLabel: PropTypes.string,
  label: PropTypes.string,
  labelElement: PropTypes.node,
  large: PropTypes.bool,
  loose: PropTypes.bool,
  name: PropTypes.string,
  tight: PropTypes.bool,
};

Fieldset.contextTypes = {
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      message: PropTypes.string,
    }),
  ),
};

Fieldset.defaultProps = {
  children: null,
  className: '',
  element: 'fieldset',
  errors: [],
  extra: null,
  groupLabel: '',
  label: '',
  labelElement: 'label',
  large: false,
  loose: false,
  name: '',
  tight: false,
};
